import { useEffect } from 'react';

import { useApiContext } from '../../contexts/apiContext';
import { useAppPlatform } from '../../utils/app';
import { useCurrentUser } from '../../utils/user';

type Props = {
  children: React.ReactNode;
};

const PlatformInfoTrackers: React.FC<Props> = ({ children }) => {
  const platform = useAppPlatform();
  const { api } = useApiContext();
  const { user, refetchUser } = useCurrentUser();
  const team = user?.default_team;

  // Set signed_up_via to the current platform only if it hasn't been set yet.
  // This is to ensure it's set only once initially and not after every sign-in.
  // The user must be signed in (team is available).
  useEffect(() => {
    if (team && team.signed_up_via === 'unknown') {
      api()
        .teams.partialUpdate({
          id: team.id,
          patchedTeamRequest: { signed_up_via: platform },
        })
        .then(refetchUser);
    }
  }, [team, team?.signed_up_via, platform]);

  // Update last_interacted_via to the current platform if it's different
  // from the one stored in the database. The user must be signed in.
  useEffect(() => {
    if (user && user?.last_interacted_via !== platform) {
      api()
        .currentUser.partialUpdate({
          patchedCustomUserRequest: { last_interacted_via: platform },
        })
        .then(refetchUser);
    }
  }, [user, user?.last_interacted_via, platform]);

  return <>{children}</>;
};

export default PlatformInfoTrackers;
